import { CheckCircleOutline } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import LoadingButton from 'components/shared/LoadingButton';
import { ROUTES } from 'constants/routes';
import React, { useCallback } from 'react';
import { useNav } from 'utils/navigation';

// Cross-App Access has no test step, so after the final save the admin stays on the guide
// and sees this saved confirmation (mirroring the SSO TestingPage "completed" panel: a
// success icon + heading + message), then leaves via an explicit Done button - instead of
// being silently redirected home.
const XAASavedConfirmation: React.FC = () => {
	const nav = useNav();

	const handleDone = useCallback(() => {
		nav(ROUTES.home);
	}, [nav]);

	return (
		<Stack gap={3} data-testid="xaa-saved-confirmation">
			<Stack gap={2}>
				<Stack direction="row" alignItems="center" gap={1}>
					<Typography variant="h3">
						{intl.tr('xaaConfig.guide.saved.title')}
					</Typography>
					<CheckCircleOutline color="success" />
				</Stack>
				<Typography>{intl.tr('xaaConfig.guide.saved.message')}</Typography>
			</Stack>
			<Stack alignItems="end">
				<LoadingButton
					data-testid="done-button"
					variant="contained"
					onClick={handleDone}
				>
					{intl.tr('general.done')}
				</LoadingButton>
			</Stack>
		</Stack>
	);
};

export default XAASavedConfirmation;
